/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsgroupaudience2Inputs */

const en_settingsgroupaudience2 = /** @type {(inputs: Settingsgroupaudience2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audience`)
};

const de_settingsgroupaudience2 = /** @type {(inputs: Settingsgroupaudience2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgruppe`)
};

/**
* | output |
* | --- |
* | "Audience" |
*
* @param {Settingsgroupaudience2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const settingsgroupaudience2 = /** @type {((inputs?: Settingsgroupaudience2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsgroupaudience2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settingsgroupaudience2(inputs)
	return de_settingsgroupaudience2(inputs)
});
export { settingsgroupaudience2 as "settingsGroupAudience" }